module.exports = __webpack_public_path__ + "b1d4c5e276e3aaa8ec41e6014dd572b2.svg";